/*
========================================
PRODUCT PREVIEW

CONFIG

Общие настройки блока preview:

- переключатели ON/OFF
- размеры элементов
- параметры свайпа
- параметры отображения
- базовые настройки для будущей админпанели

Примеры:
- включена ли анимация
- ширина ручек шторок
- размер мини-картинок
- порог свайпа
========================================
*/

/*
========================================
PRODUCT PREVIEW

CONFIG

Централизованные настройки:

- тексты интерфейса
- константы размеров
- подготовка к админ-панели

В будущем:
тексты могут приходить из CMS
или dashboard Medusa
========================================
*/

export const PRODUCT_PREVIEW_HANDLE_WIDTH = 44

export function getProductPreviewText(locale: string | null) {

  if (locale === "ru-RU") {
    return {
      want: "Хотят",
      have: "Уже есть",
      recommend: "Рекомендуют",
      comments: "Комментарии",

      pointsTitle: "Ваш бонус",
      pointsValue: "35 баллов",
      pointsHint: "Действуют 30 дней",

      joinTitle: "Примите участие",
      joinText:
        "Нажмите кнопку, выберите вариант и получите баллы за участие.",
      joinButton: "Участвовать",

      comment1: "Удобная вещь, реально пригодилась.",
      comment2: "У меня уже есть похожий, могу рекомендовать.",

      addToCart: "В корзину",
      currentPrice: "Цена",
    }
  }

  if (locale === "he-IL") {
    return {
      want: "רוצים",
      have: "כבר יש",
      recommend: "ממליצים",
      comments: "תגובות",

      pointsTitle: "הבונוס שלך",
      pointsValue: "35 נקודות",
      pointsHint: "בתוקף ל-30 יום",

      joinTitle: "הצטרפו להשתתפות",
      joinText:
        "לחצו על הכפתור, בחרו אפשרות וקבלו נקודות על ההשתתפות.",
      joinButton: "להשתתף",

      comment1: "מוצר שימושי, באמת עזר לי.",
      comment2: "כבר יש לי משהו דומה, ואני ממליץ.",

      addToCart: "הוסף לסל",
      currentPrice: "מחיר",
    }
  }

  return {
    want: "Want this",
    have: "Already have",
    recommend: "Recommend",
    comments: "Comments",

    pointsTitle: "Your bonus",
    pointsValue: "35 points",
    pointsHint: "Valid for 30 days",

    joinTitle: "Take part",
    joinText:
      "Tap the button, choose an option, and earn points for joining.",
    joinButton: "Participate",

    comment1: "Useful item, really came in handy.",
    comment2: "I already have something similar and can recommend it.",

    addToCart: "Add to cart",
    currentPrice: "Price",
  }

}